import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { BookOpenText } from "lucide-react";
import FetchQuestionsInQuiz from "./FetchQuestionsInQuiz";

const ChooseQuestionModal = ({ addQuestion, questionNum }) => {
  return (
    <Accordion type="single" collapsible className="w-full my-2">
      <AccordionItem value={`item-${questionNum}`}>
        <AccordionTrigger className="hover:no-underline">
          <button
            type="button"
            className="text-right hover:cursor-pointer text-lg px-4 py-2 bg-green-700 text-white rounded-lg flex items-center gap-2"
          >
            <BookOpenText className="size-5" />
            أضف هذا السؤال من بنك الأسئلة
          </button>
        </AccordionTrigger>
        <AccordionContent className="p-4 bg-green-50 rounded-lg border border-green-400">
          <h5 className="text-lg font-bold mb-4">إختر السؤال</h5>
          <FetchQuestionsInQuiz
            addQuestion={addQuestion}
            questionNum={questionNum}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );

  return (
    <>
      <div
        className="accordion border-0 my-2 bg-transparent bg-ea-base rounded-ea"
        id={`accordionExample-${questionNum}`}
      >
        <div className="accordion-item border-0 bg-transparent">
          <h2
            className="accordion-header border-0 bg-transparent"
            id={`headingOne-${questionNum}`}
          >
            <button
              className="accordion-button border-0 bg-transparent"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapseOne-${questionNum}`}
              aria-expanded="false"
              aria-controls={`collapseOne-${questionNum}`}
              id={`acc-btn-${questionNum}`}
            >
              <button type="button" className="rounded-ea">
                أضف هذا السؤال من بنك الأسئلة
              </button>
            </button>
          </h2>
          <div
            id={`collapseOne-${questionNum}`}
            className="accordion-collapse collapse show border-0 bg-transparent"
            aria-labelledby={`#headingOne-${questionNum}`}
            data-bs-parent={`#accordionExample-${questionNum}`}
          >
            <div className="accordion-body">
              <h5
                className="modal-title"
                id={`staticBackdropLabel${questionNum}`}
              >
                إختر السؤال
              </h5>
              <FetchQuestionsInQuiz
                addQuestion={addQuestion}
                questionNum={questionNum}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChooseQuestionModal;
